import { render, staticRenderFns } from "./PublicNotice.vue?vue&type=template&id=b49692c4&scoped=true"
import script from "./PublicNotice.vue?vue&type=script&lang=js"
export * from "./PublicNotice.vue?vue&type=script&lang=js"
import style0 from "./PublicNotice.vue?vue&type=style&index=0&id=b49692c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49692c4",
  null
  
)

export default component.exports